import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { SelectedGradeStateService } from '@app/infrastructure/core/services/state/selected-grade-state.service';
import { GradeLevel, GradeRoute } from '@models/grade-level';
import { INavigation } from '@models/navigation';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'app-grades-selector',
  template: `
    <app-grades-selector-presentation
      [headerStyle]="headerStyle"
      [gradeLevelList]="gradeLevelList"
      [selectedGrade]="selectedGrade$ | async"
      [routeOnClick]="routeOnClick"
      (gradeSelection)="selectGrade($event)"
    ></app-grades-selector-presentation>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradesSelectorSmartComponent implements OnInit {
  @Input() public headerStyle: boolean = false;
  @Input() public routeOnClick: boolean = true;

  @Output() public gradeSelection = new EventEmitter<number>();
  public gradeLevelList: INavigation[] = [];
  public selectedGrade$: BehaviorSubject<number>;
  public selectedGrade: number;

  constructor(private selectedGradeState: SelectedGradeStateService) {}

  public ngOnInit(): void {
    this.gradeLevelList = this.buildGradeLevelList();
    this.selectedGrade$ = SelectedGradeStateService.selectedGrade$;
  }

  private buildGradeLevelList(): INavigation[] {
    const gradeLevelList: INavigation[] = [
      {
        id: 0,
        label: GradeLevel.TRANSITIONAL_KINDERGARTEN,
        link: 'grades/' + GradeRoute.TRANSITIONAL_KINDERGARTEN + '/units',
        icon: 'assets/img/tk-cricket.png',
      },
      {
        id: 1,
        label: GradeLevel.KINDERGARTEN,
        link: 'grades/' + GradeRoute.KINDERGARTEN + '/units',
        icon: 'assets/img/Grade_0_Kinder_Icon.png',
      },
      {
        id: 2,
        label: 'Level I',
        link: 'grades/' + GradeRoute.FIRST + '/units',
        icon: 'assets/img/Grade_1_Icon.png',
      },
      {
        id: 3,
        label: 'Level II',
        link: 'grades/' + GradeRoute.SECOND + '/units',
        icon: 'assets/img/Grade_2_Icon.png',
      },
      {
        id: 4,
        label: 'Level III',
        link: 'grades/' + GradeRoute.THIRD + '/units',
        icon: 'assets/img/Grade_3_Icon.png',
      },
      {
        id: 5,
        label: 'Level IV',
        link: 'grades/' + GradeRoute.FOURTH + '/units',
        icon: 'assets/img/Grade_4_Icon.png',
      },
      {
        id: 6,
        label: 'Level V',
        link: 'grades/' + GradeRoute.FIFTH + '/units',
        icon: 'assets/img/Grade_5_Icon.png',
      },
      {
        id: 7,
        label: 'Level VI',
        link: 'grades/' + GradeRoute.SIXTH + '/units',
        icon: 'assets/img/Grade_6_Icon.png',
      },
    ];

    return gradeLevelList;
  }

  selectGrade(id: number) {
    this.selectedGrade$.next(id);
    this.gradeSelection.emit(id);
  }
}
